import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  container: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '85%',
    height: '85%',
    borderRadius: '0.5rem',
    display: 'flex',
    //alignItems: "stretch",
    flexDirection: 'column',
    backgroundColor: '#1C1C1C',
    padding: '2rem 2rem',
    wordBreak: 'keep-all!important',
    overflowY: 'auto',
    '&:active': {
      outline: 'none',
    },
    '&:focus': {
      outline: 'none',
    },
    '&::-webkit-scrollbar': {
      width: '8px',
      marginRight: '5px',
    },
    '&::-webkit-scrollbar-track': {
      background: '#292929',
      borderRadius: '10px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#404040',
      borderRadius: '10px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: '#9A9A9A',
    },
    '&::-webkit-scrollbar-thumb:active': {
      background: '#9A9A9A',
    },
  },
  pageTitle: {
    [theme.breakpoints.down('sm')]: {
      marginTop: '1rem',
    },
    fontSize: '1.8rem',
    color: '#fff',
    alignItems: 'center',
    display: 'flex',
  },
  separater: {
    borderBottomWidth: '1px',
    borderBottomColor: '#A4A4A4',
    borderBottomStyle: 'solid',
    margin: '1.5rem 0',
  },
  inputSourceButtonContainer: {
    [theme.breakpoints.down('544')]: {
      width: '100%',
      fontSize: '13px',
    },
    [theme.breakpoints.down('476')]: {
      width: '100%',
      fontSize: '11px',
    },
    width: '25rem',
    fontSize: '13px',
    marginTop: '.3rem',
    marginBottom: '1rem',
    backgroundColor: '#818181',
    padding: '0.2rem',
    alignSelf: 'start',
  },
  inputSourceButton: {
    [theme.breakpoints.down('xs')]: {
      padding: '0.2rem 1rem!important',
    },
    flex: 1,
    fontWeight: '400',
    backgroundColor: '#818181!important',
    color: '#000!important',
    padding: '0.2rem 1rem!important',
    border: 'none!important',
  },

  cardGrid: {
    borderRadius: '8px !important',
    gap: '16px',
    overflowY: 'auto',
    scrollBehavior: 'smooth',
    '&::-webkit-scrollbar': {
      width: '8px',
      marginRight: '5px',
    },
    '&::-webkit-scrollbar-track': {
      background: '#292929',
      borderRadius: '10px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#404040',
      borderRadius: '10px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: '#9A9A9A',
    },
    '&::-webkit-scrollbar-thumb:active': {
      background: '#9A9A9A',
    },
  },
  selectModelButton: {
    [theme.breakpoints.down('xs')]: {
      width: `7.6rem`,
      height: '7.6rem',
      gap: '0.5rem',
      fontSize: '10px',
    },
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '1rem',
    width: `10rem`,
    height: '10rem',
    borderWidth: 2,
    backgroundColor: '#292929',
    border: '1px dashed #404040',
    borderRadius: '8px',
    //transition: "border .24s ease-in-out",
    fontSize: '14px',
    cursor: 'pointer',
  },
  addButtonImg: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '2rem',
    },
    fontSize: '54px !important',
    color: '#9A9A9A',
  },
  dragAndDropText: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '10px',
    },
    fontWeight: '300',
    fontSize: '14px',
    color: '#9A9A9A',
  },
  card: {
    [theme.breakpoints.down('xs')]: {
      width: `7.6rem`,
      height: '7.6rem',
      fontSize: '1rem',
    },
    flex: '0 0 auto',
    width: `10rem`,
    height: '10rem',
    backgroundColor: '#161616',
    borderRadius: '0.5rem',
    color: '#fff',
    fontSize: '1.5rem',
    fontWeight: '400',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    cursor: 'pointer',
  },
  coverImg: {
    [theme.breakpoints.down('xs')]: {
      width: `7.6rem`,
      height: '7.6rem',
    },
    position: 'absolute',
    zIndex: '0',
    borderRadius: '0.4rem',
    width: `10rem`,
    height: '10rem',
    objectFit: 'cover',
  },
  usageTag: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '8px',
    },
    position: 'absolute',
    zIndex: '3',
    borderRadius: '1rem',
    padding: '3px 5px',
    fontSize: '11px',
    fontWeight: '400',
    color: '#000',
    backgroundColor: '#fff',
    top: '8px',
    left: '8px',
    border: '1px solid #e2e2e2',
  },
  cardContent: {
    [theme.breakpoints.down('xs')]: {
      padding: '4px',
      gap: '1px',
    },
    position: 'absolute',
    width: '100%',
    zIndex: '2',
    display: 'flex',
    flexDirection: 'column',
    alightItems: 'center',
    gap: '6px',
    borderRadius: '0 0 0.5rem 0.5rem',
    bottom: '0',
    backgroundColor: 'rgb(0, 0, 0, 0.6)',
    padding: '6px',
  },
  cardLabel: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.7rem',
      lineHeight: '1.1rem',
    },
    flex: 1,
    fontSize: '1rem',
    lineHeight: '1.5rem',
    overflowWrap: 'anywhere',
    display: '-webkit-box',
    WebkitLineClamp: 1,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  cardTimestamp: {
    //marginTop: "3.3rem",
    // alightItems: 'flex-end',
    display: 'flex',
    // marginLeft: '0.3rem',
    flex: 1,
    fontSize: '0.65rem',
    color: '#d3d3d3',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    //whiteSpace: "nowrap",
    [theme.breakpoints.down(476)]: {
      fontSize: '0.5rem',
    },
  },
  loading: {
    alignSelf: 'center',
  },
}));

export { useStyles };
